
  var _styles = {
  "recommend4-price-logo": {
    "width": "4.6rem",
    "height": "1.65333rem",
    "borderRadius": "0.24rem",
    "backgroundColor": "rgb(255,255,255)",
    "position": "relative",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between"
  },
  "recommend4-price-logo-tag": {
    "width": "1.38667rem",
    "height": "0.37333rem",
    "position": "absolute",
    "top": 0,
    "left": 0,
    "borderRadius": "0.24rem 0 0.24rem 0",
    "overflow": "hidden",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "recommend4-price-logo-tag-text": {
    "fontSize": "0.26667rem",
    "fontWeight": "500",
    "lineHeight": "0.26667rem",
    "fontFamily": "PingFang SC"
  },
  "recommend4-city-name": {
    "lineHeight": "0.56rem",
    "color": "rgb(34,34,34)",
    "fontSize": "0.37333rem",
    "fontWeight": "500"
  },
  "recommend4-rmb": {
    "color": "rgb(255,102,0)",
    "fontSize": "0.32rem",
    "fontWeight": "500",
    "fontFamily": "PingFang SC"
  },
  "recommend4-rmb-small": {
    "fontSize": "0.26667rem"
  },
  "recommend4-price": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "baseline"
  },
  "recommend4-price-icon": {
    "width": "0.32rem",
    "height": "0.64rem",
    "fontSize": "0.32rem",
    "fontWeight": "500",
    "lineHeight": "0.32rem",
    "paddingTop": "0.26667rem",
    "paddingLeft": "0.05333rem",
    "color": "rgb(255,75,16)"
  },
  "recommend4-small-price": {
    "fontSize": "0.37333rem"
  },
  "recommend4-left-content": {
    "height": "100%",
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "space-between"
  },
  "recommend4-city": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "recommend4-city-departCityName": {
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "lineHeight": "0.56rem"
  },
  "recommend4-city-arriveCityName": {
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "lineHeight": "0.56rem"
  },
  "recommend4-small-text": {
    "fontSize": "0.32rem"
  },
  "recommend4-arrow": {
    "marginTop": "-0.02667rem",
    "marginLeft": "0.16rem",
    "marginRight": "0.16rem"
  },
  "recommend4-right-content": {
    "paddingTop": "0.33333rem",
    "height": "100%",
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "space-between",
    "alignItems": "flex-end"
  },
  "recommend4-price-price-number": {
    "fontSize": "0.48rem",
    "lineHeight": "0.64rem",
    "color": "rgb(255,75,16)",
    "fontFamily": "MTNewDigitalDisplay-Bold"
  },
  "recommend4-font-grey-container": {
    "height": "0.57333rem",
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "center",
    "alignItems": "flex-start"
  },
  "recommend4-font-grey": {
    "color": "rgb(102,102,102)",
    "fontSize": "0.32rem",
    "fontWeight": "400",
    "fontFamily": "PingFang SC"
  },
  "recommend4-price-text": {
    "fontSize": "0.48rem",
    "fontWeight": "500",
    "color": "rgb(255,102,0)",
    "fontFamily": "PingFang SC",
    "lineHeight": "0.48rem"
  },
  "recommend4-discout-text-container": {
    "height": "0.37333rem",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center",
    "paddingTop": 0,
    "paddingRight": "0.06667rem",
    "paddingBottom": 0,
    "paddingLeft": "0.06667rem",
    "borderWidth": "0.01333rem",
    "borderStyle": "solid",
    "borderColor": "rgb(255,75,16)",
    "borderRadius": "0.08rem"
  },
  "recommend4-discout-text": {
    "lineHeight": "0.37333rem",
    "fontSize": "0.26667rem",
    "color": "rgb(255,75,16)",
    "fontFamily": "MTNewDigitalDisplay-Regular"
  }
};

  if (typeof FontFace === 'function') {
    
    var fontFace0 = new FontFace('MTNewDigitalDisplay-Regular', 'url("https://s3plus.meituan.net/s3plus-specialgroup-hfe/fonts/MTNewDigitalDisplay-Regular.otf") format("opentype")');
    document.fonts.add(fontFace0);
    
    var fontFace1 = new FontFace('MTNewDigitalDisplay-Bold', 'url("https://s3plus.meituan.net/s3plus-specialgroup-hfe/fonts/MTNewDigitalDisplay-Bold.otf") format("opentype")');
    document.fonts.add(fontFace1);
    
  }
    


  module.exports = _styles;
  